import { TOGGLE_LOADER } from '../../constants/redux-events';

export const toggleLoader = (payload) => ({ type: TOGGLE_LOADER, payload });
